module.exports = __webpack_public_path__ + "static/slide8-people-827c79aecc29dbbbb1a128107a634d1c.jpg";